// function loadCRMWidget() {
//   (function (w, d, u) {
//     const s = d.createElement('script');
//     s.async = true;
//     s.src = `${u}?${(Date.now() / 60000) | 0}`;
//     const h = d.getElementsByTagName('script')[0];
//     if (h && h.parentNode) h.parentNode.insertBefore(s, h);
//   })(window, document, 'https://crm.reforce.group/upload/crm/site_button/loader_2_id15uc.js');
// }

function loadDmp() {
  var script = document.createElement('script');
  script.src = 'https://p.dmp.one/sync?stock_key=5e931afb82eb321b6410843215d7283f';
  script.async = true;
  script.referrerPolicy = 'no-referrer-when-downgrade';
  script.charset = 'UTF-8';
  document.head.appendChild(script);
}

function loadCrm2ChatWidget() {
  if (
    document.getElementById('crm2-chat-widget-script') ||
    document.querySelector('[data-chatbot-host="1"]')
  ) {
    return;
  }

  const d = document;
  const s = d.createElement('script');
  s.id = 'crm2-chat-widget-script';
  s.src = 'https://crm2.reforce.group/static/chat-widget.js';
  s.defer = true;
  s.setAttribute('data-token', 'reforce_mHd_sjA1Hd7U7X0iDOSVAIMI-LkfG0zu');
  const h = d.getElementsByTagName('script')[0];
  if (h && h.parentNode) {
    h.parentNode.insertBefore(s, h);
  } else {
    d.head.appendChild(s);
  }
}

function unloadCrm2ChatWidget() {
  const script = document.getElementById('crm2-chat-widget-script');

  if (script) {
    script.remove();
  }

  document
    .querySelectorAll(
      [
        '[data-chatbot-host="1"]',
        'iframe[src*="crm2.reforce.group"]',
        'script[src*="crm2.reforce.group"]',
      ].join(','),
    )
    .forEach((element) => element.remove());
}

function syncCrm2ChatWidget(shouldShow) {
  if (shouldShow) {
    loadCrm2ChatWidget();
  } else {
    unloadCrm2ChatWidget();
  }
}

function loadYandexMetrika() {
  (function (m, e, t, r, i, k, a) {
    m[i] =
      m[i] ||
      function () {
        (m[i].a = m[i].a || []).push(arguments);
      };
    m[i].l = 1 * new Date();
    ((k = e.createElement(t)), (a = e.getElementsByTagName(t)[0]));
    k.async = 1;
    k.src = r;
    a.parentNode.insertBefore(k, a);
  })(window, document, 'script', 'https://mc.yandex.ru/metrika/tag.js?id=109719146', 'ym');

  ym(109719146, 'init', {
    ssr: true,
    webvisor: true,
    clickmap: true,
    ecommerce: 'dataLayer',
    referrer: document.referrer,
    url: location.href,
    accurateTrackBounce: true,
    trackLinks: true,
  });
}

function loadAllExternalScripts() {
  loadYandexMetrika();
  loadDmp();
}

window.ExternalScripts = {
  loadAll: loadAllExternalScripts,
  syncCrm2ChatWidget,
};
